
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { css } from '../../../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js';

var inputError = function inputError(_ref) {
  var formElements = _ref.formElements;
  return /*#__PURE__*/ /*#__PURE__*/css("color:", formElements.errors.errorBorderColor, ";margin-inline-start:0.25rem;" + (process.env.NODE_ENV === "production" ? "" : ";label:inputError;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFNEUiLCJmaWxlIjoic3R5bGVzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgY3NzLCBUaGVtZSwgU2VyaWFsaXplZFN0eWxlcyB9IGZyb20gXCJAZW1vdGlvbi9yZWFjdFwiO1xuXG5leHBvcnQgY29uc3QgaW5wdXRFcnJvciA9ICh7IGZvcm1FbGVtZW50cyB9OiBUaGVtZSk6IFNlcmlhbGl6ZWRTdHlsZXMgPT4gY3NzYFxuICBjb2xvcjogJHtmb3JtRWxlbWVudHMuZXJyb3JzLmVycm9yQm9yZGVyQ29sb3J9O1xuICBtYXJnaW4taW5saW5lLXN0YXJ0OiAwLjI1cmVtO1xuYDtcbiJdfQ== */", process.env.NODE_ENV === "production" ? "" : ";label:inputError;");
};

export { inputError };
//# sourceMappingURL=styles.js.map
